import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import styles from './FeatureMap.module.css';
import img from '../assets/10.jpg';

const FeatureMap = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end end"]
  });
  
  // Scale the background image drastically to act like a camera zoom as requested
  const scaleImage = useTransform(scrollYProgress, [0, 0.4, 0.8, 1], [1, 1.4, 8, 60]);
  
  // Fade out text as we zoom deep so it transitions smoothly to the next section
  const textOpacity = useTransform(scrollYProgress, [0, 0.6, 0.9], [1, 1, 0]);

  // Optionally fade to black or darker overlay at the very end
  const overlayOpacity = useTransform(scrollYProgress, [0.7, 1], [0.65, 1]);

  const containerVars = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { staggerChildren: 0.12 }
    }
  };

  const itemVars = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } }
  };

  return (
    <div ref={ref} className={styles.scrollContainer}>
      <div className={styles.stickyViewport}>
        <motion.div 
          className={styles.bg}
          style={{ 
            backgroundImage: `url(${img})`,
            scale: scaleImage,
            transformOrigin: "center center"
          }}
        />
        <motion.div 
          className={styles.overlay} 
          style={{ backgroundColor: "rgba(7, 8, 14, 1)", opacity: overlayOpacity }}
        />

        <motion.div className={styles.content} style={{ opacity: textOpacity }}>
          <motion.div 
            className={styles.textContent}
            variants={containerVars}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
          >
            <motion.div variants={itemVars} className={styles.eyebrow}>
              MAP IT
            </motion.div>
            <motion.h2 variants={itemVars} className={styles.title}>
              Your city,<br/>measured.
            </motion.h2>
            <motion.p variants={itemVars} className={styles.body}>
              Every reading you take is instantly pinned to the map for anyone to see. Filter by date and hour to explore how noise shifts across neighborhoods, day and night.
            </motion.p>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default FeatureMap;
